<template>
  <div class="mobile-wrapper">
    <div class="inner">
      <i class="devices-1"></i>
      <img src="~assets/images/bg/logo-5-dark.png" class="logo">
      <p>{{ $t('web_message_resolution_notsupported') }}</p>
      <a href="#" @click.prevent="goHowItWorks">{{$t('public_epg_blocker_message1')}}</a>
      <a href="#" @click.prevent="register">{{$t('public_epg_blocker_message2')}}</a>
    </div>
    <div class="blur">
      <div class="blur-inner">
      <p>{{ $t('web_install_app_description') }}</p>
      <div class="download">
      <a href="https://itunes.apple.com/us/app/eon/id490106327?mt=8" class="app-store" :class="{hidden: isAndroid}"><img src="~assets/images/bg/apple-btn.png" alt="app store"></a>
      <a href="https://play.google.com/store/apps/details?id=com.ug.eon.android" class="google-store" :class="{hidden: isIOS}"><img src="~assets/images/bg/google-btn.png" alt="google store"></a>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import deviceDetector from 'helpers/device/deviceDetector'
import { getEonUrl } from 'helpers/baseURLhelper'

export default {
  name: 'MobileDetect',
  computed: {
    isIOS: function () {
      return deviceDetector.isIos
    },
    isAndroid: function () {
      return deviceDetector.isAndroid
    }
  },
  methods: {
    goHowItWorks: function () {
      window.open(`${getEonUrl()}/how-it-works`, '_blank')
    },
    register: function () {
      window.open(`${getEonUrl()}/register`, '_blank')
    }
  },
  created: function () {
    document.body.className += ' mobile'
  }
}

</script>

<style scoped lang="scss">
  @import "uc/_variables";
  /*@import 'uc/_mixins';*/

.mobile-wrapper {
    width: 320px;
    height: 100vh;
    min-height: 510px;
    text-align: center;
    margin: 0 auto;
    color: #555555;
}
.inner {
    position: relative;
    top: 47%;
    transform: translateY(-50%) translateY(-90px);
    margin-left: 20px;
    margin-right: 20px;
        a {
            display: block;
            padding-top: 12px;
            padding-bottom: 12px;
            font-size: 18px;
            letter-spacing: -0.1px;
            background-color: #ffffff;
            color: #555555;
            border-radius: 4px;
            transition: background-color 200ms, color 200ms;
                &:active {
                  background-color: #0095da;
                  color: #ffffff;
                }
        }
}
.hidden {
    display: none;
}
.logo {
    margin-bottom: 26px;
    image-rendering: -webkit-optimize-contrast;
    // image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: crisp-edges;
}
p {
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 30px;
}
.blur {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
}
.blur-inner {
    width: 280px;
    margin: 20px auto 0;
        p {
            font-size: 16px;
            margin-bottom: 20px;
            color: #555555;
        }
}
a {
    display: inline-block;
    margin-bottom: 20px;
}
a img {
    width: 270px;
}
</style>



// WEBPACK FOOTER //
// src/containers/sections/MobileDetect/_main.vue